import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import {
  Card,
  CardHeader,
  Heading,
  CardBody,
  Link,
  VStack,
  Tag,
  Text,
} from "@chakra-ui/react";

import { CardDivider } from "@components";
import { ModuleLocation, getHumanReadableStepName } from "@constants";

type ModuleGridItemProps = {
  moduleName: string;
  step?: string;
  location: ModuleLocation;
};

/**
 * A component that displays high level information about a module and the next
 * step that needs to be performed on it.
 * @param {string} moduleName Name of the module
 * @param {string} step Next step to be performed.
 * @param {ModuleLocation} location Location of the module currently.
 */
export function ModuleGridItem({
  moduleName,
  step,
  location,
}: ModuleGridItemProps) {
  return (
    <Card>
      <CardHeader>
        <Heading as="h3" size="md">
          <Link as={ReactRouterLink} to={`/modules/${moduleName}`}>
            {moduleName}
          </Link>
        </Heading>
      </CardHeader>
      <CardDivider />
      <CardBody as={VStack} alignItems="stretch">
        {step ? (
          <Link as={ReactRouterLink} to={`/production/${step}`}>
            {getHumanReadableStepName(step)} <Text as="em">up next.</Text>
          </Link>
        ) : undefined}
        <Tag size="md" borderRadius="full" alignSelf="flex-start">
          {location.inTransit
            ? `In Transit to ${location.destination}`
            : location.location}
        </Tag>
      </CardBody>
    </Card>
  );
}
